export const pspFormValuesMap = {
  IN: {
    "Form Code": "WF_PSP_CONTACT_US",
    "Page Name": "PSP Contact Us",
  },
};